import { SubscriptionRoutesEnum } from "@utilities/enums";
import { fetchRequest } from "@utilities/requests";

export const subscriptionService =  {

    getAllPlans: async ()=> {
        return await fetchRequest({
            route: SubscriptionRoutesEnum.SUBSCRIPTION_PLAN_GET_ALL_PLANS,
            method: 'GET',
        });
    },

    getOrganisationSubscriptionModules: async (organisationID: string) => {
        return await fetchRequest({
            route: `${SubscriptionRoutesEnum.SUBSCRIPTION_PLAN_GET_ORGANISATION_SUBSCRIPTION_MODULES}/${organisationID}`,
            method: 'GET',
        });
    },

    initSubscriptionModule: async (organisationID: string) => {
        return await fetchRequest({
            route: `${SubscriptionRoutesEnum.SUBSCRIPTION_PLAN_INIT_SUBSCRIPTION_MODULE}/${organisationID}`,
            method: 'POST',
        });
    },

    getNextInvoiceDetails: async (organisationID: string) => {
        return await fetchRequest({
            route: `${SubscriptionRoutesEnum.SUBSCRIPTION_PLAN_GET_NEXT_INVOICE_DETAILS}/${organisationID}`,
            method: 'GET',
        });
    },

    getOrganisationInvoiceHistory: async (organisationID: string) => {
        return await fetchRequest({
            route: `${SubscriptionRoutesEnum.SUBSCRIPTION_PLAN_GET_ORGANISATION_INVOICES}/${organisationID}`,
            method: 'GET',
        });
    },

    updateOrganisationModules: async (organisationID: string, name: string, option: string, price: number)=> {
        return await fetchRequest({
            route: `${SubscriptionRoutesEnum.SUBSCRIPTION_PLAN_UPDATE_ORGANISATION_MODULES}/${organisationID}`,
            method: 'PUT',
            data: { name, option, price }
        });
    }

};
